import { en } from '../../locales/en';
import { Text } from '../general/Text';
import Dialog from './Dialog';
import { useGcsStore } from '../../store/useGcsStore';

interface AnotherConnectionDetectedDialogProps {
  gcsId: string;
  onClose: () => void;
}

export function AnotherConnectionDetectedDialog({ gcsId, onClose }: AnotherConnectionDetectedDialogProps) {
  const connect = useGcsStore((state) => state.connect);

  const onKeepPreviousClicked = () => {
    connect(gcsId, { 'single-conn-mode': 'keep-prev' });
    onClose();
  };

  const onUseHereClicked = () => {
    connect(gcsId, { 'single-conn-mode': 'use-here' });
    onClose();
  };

  return (
    <Dialog
      onClose={undefined} // This dialog cannot be closed
      title={en.anotherConnectionDetectedDialog.title}
      secondaryButtonProps={{
        text: en.anotherConnectionDetectedDialog.keepPreviousButton,
        callback: onKeepPreviousClicked
      }}
      primaryButtonProps={{
        text: en.anotherConnectionDetectedDialog.useHereButton,
        callback: onUseHereClicked
      }}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.anotherConnectionDetectedDialog.body.replace('{gcsId}', gcsId)}</Text>
      </div>
    </Dialog>
  );
}
